import Button from "@ui-kit/form/Button/Button.web";
import Box from "@ui-kit/layout/Box/Box.web";
import Input from "@ui-kit/form/Input/Input.web";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import Text from "@ui-kit/typography/Text/Text.web";
import {
  NEWSLETTER_ACTION_URL,
  NEWSLETTER_LID,
  NEWSLETTER_MID,
  NEWSLETTER_THX_URL,
  NEWSLETTER_ERR_URL,
} from "@shared/env";
import { Formik } from "formik";
import { useTranslation } from "@shared/utils/internationalization";
import { useRef } from "react";
import * as yup from "yup";
import { NewsletterSignupProps } from "./NewsletterSignup.props";

const NewsletterSignup = ({
  title,
  buttonText,
  placeholder,
}: NewsletterSignupProps) => {
  const { t } = useTranslation("common");

  const formEl = useRef(null);

  const doHtmlFormPost = () => {
    formEl.current.submit();
  };

  const newsletterSignUpValidationSchema = yup.object().shape({
    "Email Address": yup
      .string()
      .required(t("Email is required"))
      .email(t("Invalid email address")),
  });
  return (
    <Box
      color="fg.inverted"
      display={{ sm: "flex" }}
      flexDirection={{ sm: "row" }}
      alignItems={{ sm: "flex-start" }}
      justifyContent={{ sm: "flex-end" }}
    >
      <Box
        as="p"
        textAlign={{ base: "center", sm: "right" }}
        fontSize="sm"
        lineHeight="md"
        mb={{ base: "xl", sm: "none" }}
        color="fg.inverted"
        display={{ sm: "inline-block" }}
        maxW={{ sm: "element.11xl" }}
        mr={{ sm: "md" }}
        pt={{ sm: "2xs" }}
      >
        {title}
      </Box>
      <Box
        color="fg.inverted"
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent={{ base: "flex-end", sm: "center" }}
        w="100%"
        mx={{ base: "auto", sm: "none" }}
        minW="element.11xl"
        maxW={{ sm: "element.16xl" }}
      >
        <Formik
          initialValues={{ "Email Address": "" }}
          onSubmit={() => {
            doHtmlFormPost();
          }}
          validationSchema={newsletterSignUpValidationSchema}
        >
          {(props) => (
            <Flex flexDirection="column" width="100%">
              <Flex
                justifyContent={{ base: "center", sm: "flex-start" }}
                w={{ base: "100%", sm: "auto" }}
              >
                <form
                  style={{ display: "flex", width: "100%" }}
                  name="subscribeForm"
                  action={NEWSLETTER_ACTION_URL}
                  ref={formEl}
                  onSubmit={props.handleSubmit}
                  method="post"
                  noValidate
                >
                  <input type="hidden" name="thx" value={NEWSLETTER_THX_URL} />
                  <input type="hidden" name="err" value={NEWSLETTER_ERR_URL} />
                  <input type="hidden" name="SubAction" value="sub" />
                  <input type="hidden" name="MID" value={NEWSLETTER_MID} />
                  <input type="hidden" name="lid" value={NEWSLETTER_LID} />
                  <input type="hidden" name="Email Type" value="HTML" />

                  <Input
                    border="none"
                    color="fg.inverted"
                    bg="primary.600"
                    display="inline-block"
                    h="element.3xl"
                    _placeholder={{ color: "fg.inverted" }}
                    maxW={{ sm: "element.11xl" }}
                    type="text"
                    name="Email Address"
                    value={props.values["Email Address"]}
                    aria-label={placeholder}
                    onChange={props.handleChange}
                    placeholder={placeholder}
                    size="sm"
                  />

                  <Box minW="element.md" />

                  <Button
                    flexGrow={1}
                    lineHeight="2xl"
                    minW="element.8xl"
                    w={{ sm: "50%" }}
                    maxW={{ sm: "element.9xl" }}
                    data-testid="newsletter-signup-button"
                    type="submit"
                    value={buttonText}
                    className="button"
                    colorPalette="light"
                    color="font.dark"
                    variant="solid"
                  >
                    {buttonText}
                  </Button>
                </form>
              </Flex>
              <Text>{props.errors["Email Address"]}</Text>
            </Flex>
          )}
        </Formik>
      </Box>
    </Box>
  );
};

export default NewsletterSignup;
